import is from 'is_js';
import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';

import { routes as markAttendanceDayView } from './MarkAttendanceDayView';
import { routes as markAttendanceCourseView } from './MarkAttendanceCourseView';
import MarkAttendance from './component';
import ViewNav from 'components/ViewNav';

export default ({ getState }) => ({
  appBars: {
    sticky: {
      'view-nav': {
        component: ViewNav,
        order: 2,
      },
    },
  },
  path: 'session/:sessionPlanId(/unit/:unitId)',
  component: MarkAttendance,
  showSessionCourseSwitch: () => {
    const state = getState();
    return PrivilegeChecker.hasPrivilege(state, Privileges.MarkAttendance.ViewDayView) &&
        PrivilegeChecker.hasPrivilege(state, Privileges.MarkAttendance.ViewCourseView);
  },
  canAccess: ({ replace, buildRoute, routes }) => {
    const state = getState();
    if (routes[routes.length - 1].path === 'attendance/:sessionPlanId') {
      if (PrivilegeChecker.hasPrivilege(state, Privileges.MarkAttendance.ViewDayView)) {
        replace(buildRoute('day'));
        return true;
      }

      if (PrivilegeChecker.hasPrivilege(state, Privileges.MarkAttendance.ViewCourseView)) {
        replace(buildRoute('course'));
        return true;
      }
    }

    return true;
  },
  indexRoute: {
    onEnter: ({ routes, location }, replace) => {
      const viewMode = getState().get('rootReducer').get('uiState').get('viewMode');
      const isInCourseView = viewMode === 'course' ||
        ! PrivilegeChecker.hasPrivilege(getState(), Privileges.MarkAttendance.ViewDayView);
      const courseViewMode = isInCourseView &&
        PrivilegeChecker.hasPrivilege(getState(), Privileges.MarkAttendance.ViewCourseView);
      replace(`${withoutTrailingSlash(location.pathname)}/${courseViewMode ? 'course' : 'day'}`);
    },
  },
  breadcrumbLabels: (props) => {
    const currentSessionNumber = getCurrentSessionNumber(getState(), props);
    const segments = [];
    if (is.number(currentSessionNumber)) {
      segments.push(`Session ${currentSessionNumber}`);
    }
    if (props.params.mode === 'edit') {
      segments.push('Edit');
    }
    return segments;
  },
  childRoutes: [
    markAttendanceDayView,
    markAttendanceCourseView,
  ],
});

function getCurrentSessionNumber(state, { params: { groupId, sessionPlanId } }) {
  let group = state.get('rootReducer').get('groups').get(groupId);
  group = group && group.data;
  return group && group.sessionPlans.data && group.sessionPlans.data.indexOf(sessionPlanId) + 1;
}

function withoutTrailingSlash(path) {
  let out = path;
  if (path.substr(path.length - 1) === '/') {
    out = path.substr(0, path.length - 1);
  }
  return out;
}



// WEBPACK FOOTER //
// ./containers/Group/Attendance/MarkAttendance/routes.js